<template lang="pug">
    v-navigation-drawer.navigation-drawer(
        v-if="!!currentUser && !!currentUser.account"
        v-model='drawer'
        app
        clipped
        dark
        permanent
        mini-variant-width='75'
        :mini-variant="mini"
        :expand-on-hover="mini"
        :key="mini"
    )
        v-list(dense)

            v-subheader.mt-4.white--text(v-if='!mini' style="margin-top: 0 !important;") {{ currentUser.account.name }}

            v-list-item(ripple link :href="railsVolieBaseUrl")
                v-list-item-action
                    v-icon mdi-home
                v-list-item-content
                    v-list-item-title Home

            v-list-item(ripple link :to="'/accounts/' + currentUser.account.account_key")                
                v-list-item-action
                    v-icon mdi-sitemap
                v-list-item-content
                    v-list-item-title Account

            v-list-item(ripple link to="/admins")
                v-list-item-action
                    v-icon mdi-key
                v-list-item-content
                    v-list-item-title Admin

            //- v-list-item(ripple link :href="railsVolieBaseUrl + '/call_screen'")
            //-     v-list-item-action
            //-         v-icon mdi-phone
            //-     v-list-item-content
            //-         v-list-item-title Call Screen

            v-list-item(ripple link to="/communication_center")
                v-list-item-action
                    v-icon mdi-headphones
                v-list-item-content
                    v-list-item-title Communication Center

            v-list-group(prepend-icon='mdi-poll' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Dashboard

                v-list-item(ripple link to="/dashboards/affinity-dashboard")
                    v-list-item-title Affinity
                    v-list-item-action
                        v-icon mdi-link-variant

                v-list-item(ripple link to="/dashboards/appointment-dashboard")
                    v-list-item-title Appointment
                    v-list-item-action
                        v-icon mdi-calendar-month

                v-list-item(ripple link to="/dashboards/big_board")
                    v-list-item-title Big Board
                    v-list-item-action
                        v-icon mdi-view-dashboard

                v-list-item(ripple link to="/dashboards/lead-dashboard")
                    v-list-item-title Lead
                    v-list-item-action
                        v-icon mdi-folder-account

                v-list-item(ripple link to="/dashboards/live-dashboard")
                    v-list-item-title Live
                    v-list-item-action
                        v-icon mdi-sync

            v-list-group(prepend-icon='mdi-cog' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Management

                v-list-item(ripple link to="/agent_visibility")
                    v-list-item-title Agent Visibility
                    v-list-item-action
                        v-icon mdi-account-group

                v-list-item(ripple link :href="railsVolieBaseUrl + '/call_campaign_management'")
                    v-list-item-title Call Campaign
                    v-list-item-action
                        v-icon mdi-cog

                v-list-item(ripple link :href="railsVolieBaseUrl + '/campaign_attempt_management'")
                    v-list-item-title Campaign Attempt
                    v-list-item-action
                        v-icon mdi-counter

                v-list-item(ripple link to="/campaign_deployments")
                    v-list-item-title Campaign Deployments
                    v-list-item-action
                        v-icon mdi-rocket-launch

                v-list-item(ripple link :href="railsVolieBaseUrl + '/hot_alerts'")
                    v-list-item-title Hot Alerts
                    v-list-item-action
                        v-icon mdi-alert-circle

                v-list-item(ripple link to="/priority_groups")
                    v-list-item-title Priority
                    v-list-item-action
                        v-icon mdi-priority-high

            v-list-item(ripple link :href="railsVolieBaseUrl + '/organizations'")
                v-list-item-action
                    v-icon mdi-office-building
                v-list-item-content
                    v-list-item-title Organizations

            v-list-item(ripple link to="/pulse/inbox")
                v-list-item-action
                    v-img.shrink.hover-img(
                        alt="Pulse Icon"
                        contain
                        src="https://volie-assets.s3.us-east-1.amazonaws.com/system/pulse_branding/PulsePrimaryLogo_Light_Icon.png"
                        :width="35"
                        style="margin-left: -4px"
                    )
                v-list-item-content(style="margin-left: -6px")
                    v-list-item-title Pulse

            v-list-item(ripple link :href="railsVolieBaseUrl + '/reports'")
                v-list-item-action
                    v-icon mdi-folder-open
                v-list-item-content
                    v-list-item-title Reports

            v-list-item(ripple link to="/tickets")
                v-list-item-action
                    v-icon mdi-ticket-outline
                v-list-item-content
                    v-list-item-title Tickets

        v-divider

        v-list(dense)
            v-list-item(ripple link :href="railsVolieBaseUrl + '/users/' + currentUser.user_key + '/edit'")
                v-list-item-action
                    v-icon mdi-account
                v-list-item-content
                    v-list-item-title Profile

            v-list-item(ripple link :href="railsVolieBaseUrl + '/docs/api'")
                v-list-item-action
                    v-icon mdi-notebook
                v-list-item-content
                    v-list-item-title Api Docs

            v-list-item(ripple link :href="railsVolieBaseUrl + '/docs/how_tos'")
                v-list-item-action
                    v-icon mdi-help-circle
                v-list-item-content
                    v-list-item-title Help

            //- v-list-item(ripple link to="/privacy_policy")
            //-     v-list-item-action
            //-         v-icon mdi-security
            //-     v-list-item-content
            //-         v-list-item-title Privacy Policy

            //- v-list-item(ripple link to="/terms_and_conditions")
            //-     v-list-item-action
            //-         v-icon mdi-clipboard-text
            //-     v-list-item-content
            //-         v-list-item-title Terms and Conditions

            v-list-item(ripple link :href="railsVolieBaseUrl + '/log_out'")
                v-list-item-action
                    v-icon mdi-logout
                v-list-item-content
                    v-list-item-title Logout

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    export default Vue.extend({
        data() {
            return {
                drawer: null,
                mini: false,
            }
        },
        methods: {
            handleWindowResize() {
                if (this.$route?.meta?.forceNavbarSize?.isMini !== undefined && this.$route?.meta?.forceNavbarSize?.isMini !== null) {
                    this.mini = (this.$route.meta.forceNavbarSize.isMini || false);
                    return;
                }

                const windowWidth = window.innerWidth;
                if (windowWidth > 1200) {
                    this.mini = false;
                } else {
                    this.mini = true;
                }
            },
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            railsVolieBaseUrl() {
                return VolieState.baseRailsUrl();
            },
        },
        components: {
        },
        props: {
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);
        },
        mounted() {
            this.handleWindowResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .navigation-drawer {
            background-color: var(--volie-blue);

            .v-list-item, .v-icon {
                color: var(--white) !important;
            }
            
            .active-item {
                background-color: var(--volie-blue);
            }

            .hover-img::v-deep(.v-image__image) {
                transition: opacity 0.2s ease, transform 0.2s ease;
            }

            .hover-img:hover::v-deep(.v-image__image) {
                opacity: 0.7;
                transform: scale(1.05);
            }
        }
    }
</style>
